import { render, staticRenderFns } from "./Guest_chat.vue?vue&type=template&id=2b16e590&scoped=true&"
import script from "./Guest_chat.vue?vue&type=script&lang=js&"
export * from "./Guest_chat.vue?vue&type=script&lang=js&"
import style0 from "./Guest_chat.vue?vue&type=style&index=0&id=2b16e590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16e590",
  null
  
)

export default component.exports